import { EAppointmentCancellationReasonType } from "@/types/backoffice/dto/appointment/appointment-cancellation-reason-types";
import { EAppointmentState } from "@/types/backoffice/dto/appointment/appointment-state-dto.ts";
import { EAppointmentType } from "@/types/backoffice/dto/appointment/appointment-type-dto.ts";

const appointmentLocale = {
  appointment: {
    editAppointment: "Mettre à jour le rendez-vous",
    manual: {
      bookManualAppointment: "Prendre un rendez-vous manuel",
      date: "Date du rendez-vous",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      comment: "Commentaire",
      minDuration:
        "Durée minimale du créneau d’intervention {totalDurationInHour} minutes,\n comprenant {duration} minutes (durée d’intervention) + 15 minutes d’aléa créneau ",
      durationWarning:
        "La durée entre le début est la fin est plus courte que la durée minimale requise ({totalDurationInMinutes} minutes), soit {totalDurationInHour} minutes",
      isForcedAppointmentQuestion:
        "Voulez-vous générer le rendez-vous dans l’outil de planification avec {serviceProviderName} ?",
    },
    updateSitePartnerAddress: "Modifier la géolocalisation du site",
    noPhone: {
      label:
        "Numéro de téléphone de l'adhérent non renseigné, cette information est obligatoire pour la prise de rendez-vous.",
      cta: "Mettre à jour l'adhérent",
    },
    noMail: {
      label: "Email de l'adhérent non renseigné, cette information est obligatoire pour la prise de rendez-vous.",
      cta: "Mettre à jour l'adhérent",
    },
    partnerAddressModal: {
      header: "Confirmation de l'adresse du site",
      addressNotFound:
        "Nous n'avons pas trouvé l'adresse saisie. Voici plusieurs propositions correspondant à votre saisie pour estimer le temps de trajet du technicien pour se rendre sur le lieu du RDV",
      registeredAddress: "Adresse du site enregistrée",
      addressSuggestions: "Propositions d'adresses",
    },
    bookedAppointmentIsCompromised:
      "Le <span style='font-weight: bolder;'>RDV</span> est <span style='font-weight: bolder;'>compromis</span>, merci de le replanifier avec l'adhérent",
    hasAlreadyBookedAppointment: "Un rendez-vous est déjà planifié. Merci d'annuler ou de modifier l'existant.",
    cancelModal: {
      header: "Confirmation d'annulation du rendez-vous",
      cancellingAppointment:
        "Vous êtes sur le point d'annuler le rendez-vous prévu pour le {startDate} entre {startTime} et {endDate}",
      editWithPencil:
        "Si vous souhaitez simplement en modifier la date, merci d'utiliser l'outil de modification représenté par un crayon.",
      whatNext: "Quelle suite doit on donner à cette annulation ?",
      reason: "Quel est le motif de cette annulation ?",
      chooseReason: "Choisir une raison",
      cancel: "Annuler le rendez-vous",
      cancellationReason: {
        [EAppointmentCancellationReasonType.DEFINITIVE]: "Annulation définitive (l'adhérent ne sera pas recontacté)",
        [EAppointmentCancellationReasonType.TEMP_SOON]:
          "Annulation temporaire, à recontacter dès que possible (l'adhérent sera recontacté dès demain)",
        [EAppointmentCancellationReasonType.TEMP_MONTH]:
          "Annulation temporaire, à recontacter dans 15 jours (l'adhérent sera recontacté d'ici 15 jours)",
      },
    },
    title: "Rendez-vous",
    bookAppointment: "Planifier un rendez-vous",
    history: {
      title: "Historique",
    },
    confirmedAppointment: "Rendez-vous confirmé le",
    states: {
      [EAppointmentState.CANCELED]: "Annulé",
      [EAppointmentState.PLANNED]: "Planifié",
      [EAppointmentState.FINALIZED]: "Finalisé",
      compromised: "Compromis",
    },
    types: {
      [EAppointmentType.TECHNICAL_MAINTENANCE]: "Entretien",
      [EAppointmentType.INSTALLATION]: "Installation V5",
      [EAppointmentType.COMPLEX_INSTALLATION]: "Installation V5 complexe",
      [EAppointmentType.UNINSTALL]: "Désinstallation",
      [EAppointmentType.ADMINISTRATIVE]: "Mise à jour administrative",
      [EAppointmentType.INSTALLATION_VX]: "Primo installation",
      [EAppointmentType.QUALITY_CONTROL]: "Contrôle qualité",
      [EAppointmentType.COMPLIANCE_CONTROL]: "Réintervention",
      [EAppointmentType.UPMARKET]: "Montée en gamme",
      [EAppointmentType.INSTALLATION_FINALIZATION]: "Finalisation d'installation",
      [EAppointmentType.PAC_INSTALLATION]: "Installation PAC",
      [EAppointmentType.PAC_REINTERVENTION]: "Réintervention PAC",
      [EAppointmentType.PAC_MAINTENANCE]: "Entretien PAC",
      [EAppointmentType.PAC_UPMARKET]: "Montée en gamme PAC",
      [EAppointmentType.PAC_FINALIZATION]: "Finalisation d'installation PAC",
      [EAppointmentType.PAC_UNINSTALL]: "Désinstallation PAC",
    },
    bookModal: {
      header: "Créneaux d’arrivée de rendez-vous",
      availabilities: {
        searchInProgress: "Recherche en cours...",
        searchInProgressLabel: "Veuillez patienter, la recherche peut prendre plusieurs secondes",
        error: "Une erreur est survenue",
        errorLabel: "Merci de réessayer ultérieurement",
        nextMonth: "Mois suivant",
        previousMonth: "Mois précédent",
      },
      confirmation: {
        flex: "Flex",
        partner: "Recherche Automatique",
        type: "Type",
        title: "Confirmation du créneau d'arrivé",
        verifyInfos: "Merci de vérifier les informations concernant le créneau d'arrivé du rendez-vous",
        date: "Date",
        slot: "Créneau d'arrivé",
        provider: "Installateur",
        bookAppointment: "Prendre rendez-vous",
        tooCloseInTimeWarning:
          "Attention la prise de RDV pour un délai inférieur à 3 heure est uniquement permise pour les services de planification.",
      },
      bookSlot: {
        confirmInProgress: "Confirmation du rendez-vous en cours...",
        confirmInProgressLabel: "Veuillez patienter, la confirmation peut prendre plusieurs secondes...",
        error: "Une erreur est survenue",
        errorLabel: "Merci de réessayer ultérieurement",
        booked: "Rendez-vous confirmé",
        bookedLabel: "Le rendez-vous a bien été confirmé, vous pouvez fermer la fenêtre",
      },
    },
    bookingForm: {
      updateReason: "Motif de modification",
      eligibleApplianceNumber: "Nombre de radiateurs et de sèches-serviettes",
      totalEligibleApplianceNumber: "Nombre d'appareils éligibles",
      appointmentType: "Type de rendez-vous",
      serviceProvider: "Prestataire d'installation",
      month: "Mois de recherche",
      search: "Rechercher des créneaux",
      searchType: "Sélection et choix du créneau horaire d'arrivée",
      searchTypeManual: "Saisie manuelle",
      searchTypeAutomatic: "Recherche automatique",
    },
    noPdlContract: {
      header: "La photo du contrat d'électricité est absente",
      pdlMissingAndElectricityContractMissing:
        "Photo de la facture d'électricité ou de l'attestation de domicile du fournisseur d'énergie de l'adhérent absente. Vous devez demander ce document à l'adhérent qu'il devra envoyer par retour du mail ou préparer pour l'intervention du technicien.",
      doNotSendMail: "Ne pas envoyer d'email",
      sendMail: "Envoyer un email",
      warningSendingMail:
        "L'adhérent a déjà été notifié lors d'un précedent envoi le {lastSendingDate}. Ne ré-envoyer que si nécessaire.",
    },
    contextual: {
      update: "Mettre à jour",
      cancel: "Annuler",
    },
    slots: "Créneaux d’arrivée",
    appointmentBooking: "Prise de rendez-vous",
    confirmation: "Confirmation",
    flex: {
      flexAvailable: "Un installateur indépendant est disponible dans ce département.",
      bookFlexAppointment: "Prendre un rendez-vous flex",
    },
    appointmentBlocked:
      "Prise de rendez-vous non disponible. Le type de logement est inconnu. Veuillez le renseigner pour pouvoir prendre un rendez-vous.",
    components: {
      calendar: {
        selected: "Sélectionné",
        errorLoadingAvailabilities: "Une erreur est survenue lors du chargement des disponibilités.",
        noAvailabilitiesThisDay: "Aucune disponibilité ce jour",
        previous: "Précédent",
        next: "Suivant",
        selectedSlot: "Créneau sélectionné :",
        confirmAppointment: "Confirmer le rendez-vous",
        availableProviders: "Prestataires disponibles",
        providerFallback: "Prestataire",
        daysShortByIndex: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
        flexibleAppointmentsAvailable: "Un installateur indépendant est disponible dans ce département",
        chooseFlexibleAppointment: "Prendre un rendez-vous flex",
        filteringByPreferredProvider: "Créneaux filtrés pour le prestataire favorisé : {provider}",
        showingAllProviders: "Affichage de tous les prestataires disponibles",
        preferredProviderDescription: "Vous consultez uniquement les créneaux de ce prestataire",
        allProvidersDescription: "Vous consultez les créneaux de tous les prestataires",
        showAllProviders: "Voir tous les prestataires",
        showPreferredProvider: "Revenir au prestataire favorisé",
        monthsShortByIndex: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
        weekLabel: {
          current: "Cette semaine",
          next: "Prochaine",
          weekPlus: "Semaine +{n}",
        },
        availabilityLabels: {
          loading: "Chargement…",
          high: "Dispo",
          medium: "Peu de dispo",
          low: "Derniers créneaux",
          none: "Aucune dispo",
        },
      },
    },
  },
};

export type AppointmentLocale = typeof appointmentLocale;
export default appointmentLocale;
